import React, { useRef } from "react";
import "./FeaturesText.scss";
import { useGSAP } from "@gsap/react";
import {
  splitTextIntoSpans,
  animateTextReveal,
  maskAnimation, // added import
} from "../../../utils/gsapAnimations";

export default function FeatureTexts({ Container }) {
  const largeTitleRef = useRef(null);
  const normalText1Ref = useRef(null);
  const normalText2Ref = useRef(null);
  const smallTitleRef = useRef(null);

  // Split text using utility function
  const largeTitleSpans = splitTextIntoSpans(
    "Smart, unified tools to power your rental business"
  );
  const normalText1Spans = splitTextIntoSpans(
    "RentlyBuzz is an online rental management platform built for landlords, property managers, and co‑living operators. We centralize listings, tenant applications, screening, lease creation, rent collection, maintenance tracking, messaging, and reporting in one secure dashboard."
  );
  const normalText2Spans = splitTextIntoSpans(
    "Automated reminders, digital payments, document e‑signing, AI‑assisted insights, and real‑time analytics reduce admin work and help you scale while delivering a modern tenant experience."
  );
  const smallTitleSpans = splitTextIntoSpans("ABOUT US", "");

  useGSAP(() => {
    // Animate small title using utility
    animateTextReveal(smallTitleRef.current, {
      trigger: Container.current,
      duration: 1.5,
      stagger: 0.09,
      start: "top 90%",
    });

    // Use maskAnimation for the large title (changed from animateTextReveal)
    maskAnimation(largeTitleRef.current, {
      trigger: Container.current,
      duration: 1,
      stagger: 0.03,
      start: "top 80%",
    });

    // Animate normal text 1 using utility
    animateTextReveal(normalText1Ref.current, {
      trigger: Container.current,
      duration: 0.5,
      stagger: 0.03,
      delay: 0.2,
      start: "top 70%",
    });

    // Animate normal text 2 using utility
    animateTextReveal(normalText2Ref.current, {
      trigger: Container.current,
      duration: 0.5,
      stagger: 0.03,
      delay: 0.2,
      start: "top 50%",
    });
  }, []);

  return (
    <div className="features-texts">
      <div className="large-title">
        <div className="small-title" ref={smallTitleRef}>
          {smallTitleSpans}
        </div>
        <span ref={largeTitleRef}>
          {/* {largeTitleSpans} */}
          <span> Smart, unified tools to power your rental business</span>
        </span>
      </div>
      <div className="normal-text" ref={normalText1Ref}>
        {normalText1Spans}
      </div>
      <div className="normal-text" ref={normalText2Ref}>
        {normalText2Spans}
      </div>
    </div>
  );
}
